import React, { Component, createRef } from 'react';
import { once } from 'lodash';
import Clipboard from 'clipboard';
import { Button } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const isIE = once(() => {
  const userAgent = document.documentElement.getAttribute('data-useragent');
  return !userAgent.includes('Edge') && /msie\s|trident\//i.test(userAgent);
});

const COPIED_STATE_DELAY = 750;

class SessionRegisterLink extends Component {
  state = {
    copied: false,
  };

  inputRef = createRef();

  buttonRef = createRef();

  componentDidMount() {
    if (!isIE()) {
      this.clipboard = new Clipboard(this.buttonRef.current);
      this.clipboard.on('success', this.handleCopySuccess);
    }
  }

  handleCopySuccess = e => {
    e.clearSelection();
    clearTimeout(this.copyTimerId);
    this.setState({ copied: true }, () => {
      this.copyTimerId = setTimeout(
        () => this.setState({ copied: false }),
        COPIED_STATE_DELAY,
      );
    });
  };

  selectInput = e => {
    const { current: input } = this.inputRef;
    if (input) {
      input.select();
    }
  };

  render() {
    return (
      <>
        <div className="mb-8 fz-base">
          <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
            {t('in_person_training.event_overview.session.link_description')}
          </Text>
        </div>
        <div className="d-f">
          <input
            className="NewInput NewInput--white NewInput--fw"
            onFocus={this.selectInput}
            onClick={this.selectInput}
            ref={this.inputRef}
            value={this.props.link}
            readOnly
          />
          {!isIE() && (
            <Button
              data-clipboard-text={this.props.link}
              ref={this.buttonRef}
              onClick={this.copyLinkToClipboard}
              className="ml-8 w-125"
            >
              {this.state.copied
                ? t('in_person_training.event_overview.session.copied')
                : t('in_person_training.event_overview.session.copy_link')}
            </Button>
          )}
        </div>
      </>
    );
  }
}

export default SessionRegisterLink;
